const namespace = {
  title: "Points forts",
  noData:
    "Découvrez ce que ce quartier a à offrir en termes de transport, de services et de caractère.",
  highlight: {
    title: "Cette zone est idéale pour",
  },
} as const;

export default namespace;
